<template>
  <div class="p_zsxq">
    <!-- <p class="zsNav">首页>展商展品>展商详情</p> -->
    <p class="zsNav"><span @click="()=>this.$router.push('/')">首页</span> > <span @click="()=>this.$router.back()">展商展品</span> > 展商详情</p>
    <div class="zsxqHeader">
      <div class="zsxqImg">
        <img v-lazy="datas.corplogo_cn" alt="" />
      </div>
      <div class="zsmz">
        <h2>{{datas.corpname_cn}}</h2>
        <p>
          <button>
            <span class="zsB1">展位号：</span><span class="zsB2">{{datas.booth}}</span>
          </button>
          <button>
            <span class="zsB1">展位面积：</span><span class="zsB2">{{datas.area}}m²</span>
          </button>
        </p>
      </div>
    </div>
    <div class="zsxqContent">
      <div class="zsnrL">
        <div>
          <h3>企业介绍</h3>
          <p>
            {{datas.introduct_cn}}
          </p>
          <div class="interactionButton" style="display:none;">
            <button :class="collect==2?'collectActive':''" @click="isCollect(datas.ocid)"><i class="iconfont icon-shoucang"></i> {{collect==2?"已收藏":"收藏"}}</button>
            <button :class="meet?'':'collectActive'" @click="isCorpApp(datas.ocid)"><i class="iconfont icon-dianhua1"></i> {{meet?"约见":"已约见"}}</button>
          </div>
        </div>
      </div>
      <div class="zsnrR">
        <h3>联系方式</h3>
        <p><i class="iconfont icon-daohang1"></i><span class="zsB1">地址：</span><span class="zsB2">{{datas.address_cn}}</span></p>
        <p><i class="iconfont icon-dianhua2"></i><span class="zsB1">电话：</span><span class="zsB2">{{datas.phone}}</span></p>
        <p><i class="iconfont icon-chuanzhen"></i><span class="zsB1">传真：</span><span class="zsB2">{{datas.fax}}</span></p>
        <p><i class="iconfont icon-youxiang2"></i><span class="zsB1">邮箱：</span><span class="zsB2">{{datas.email}}</span></p>
        <p><i class="iconfont icon-wangzhi"></i><span class="zsB1">网址：</span><span class="zsB2">{{datas.website}}</span></p>
      </div>
    </div>
    <div class="exchange">
      <div class="exchangeItem">
        <div class="exchangeTop">
          <span>在线收藏夹</span>
          <img v-lazy="hrefurl+'/public/icon/enshrine.png'" alt=""/>
        </div>
        <div class="exchangeBtn">
          <button :class="collect==2?'btnACtive':''" @click="isCollect(datas.ocid)" @mouseover="inquiry1=true" @mouseout="inquiry1=false">
            <img v-lazy="collect==2||inquiry1?hrefurl+'/public/icon/like_1.png':hrefurl+'/public/icon/enshrine_2.png'" alt=""/>
            {{collect==2?"已&nbsp;收&nbsp;藏":"收&nbsp;藏"}}
          </button>
        </div>
      </div>
      <div class="exchangeItem">
        <div class="exchangeTop">
          <span>约见洽谈</span>
          <img v-lazy="hrefurl+'/public/icon/pack.png'" alt=""/>
        </div>
        <div class="exchangeBtn1">
          <button :class="meet?'':'btnACtive'" @click="isCorpApp(datas.ocid)" >
            <img v-lazy="hrefurl+'/public/icon/pack_1.png'" alt=""/>
            {{meet?"约&nbsp;见":"已&nbsp;约&nbsp;见"}}
          </button>
        </div>
      </div>
    </div>
    <div class="zplb">
      <Product :xgcp="xgcp" />
    </div>
    <div class="zxkf">
      <div class="divimg"></div>
      <p>联系我们</p>
      <!-- <img src="https://e.cippe.com.cn/public/images/onlineCustomerService.gif" alt=""> -->
      <div class="zxkfPopover">
        <!-- <div></div> -->
        如需咨询展商/展品，<br>
        请联系组委会索取资料！<br>
        电话：<span style="color: #008baf;">010-56176968</span>
      </div>
    </div>
    <!-- 约见弹窗 start -->
    <el-dialog class="yuyue" title="在线预约" :visible.sync="dialogFormVisible" :before-close="resetForm" width="650px" top="3vh">
      <el-form ref="preAboutData" :model="preAboutData" :rules="rules" label-width="100px" size="mini">
        <el-form-item label="预约日期" prop="date">
          <el-date-picker type="date" placeholder="选择日期" v-model="preAboutData.date" :picker-options='pickerOptions' style="width: 100%;"></el-date-picker>
        </el-form-item>
        <el-form-item label="留言" prop="connet">
          <el-input type="textarea" maxlength="20" show-word-limit placeholder="请输入预约主题" v-model="preAboutData.connet"></el-input>
        </el-form-item>
        <el-form-item size="large" style="text-align: center;margin-left:-100px">
          <el-button type="primary" @click="submitForm('preAboutData')">立即预约</el-button>
          <el-button @click="resetForm('preAboutData')">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 约见弹窗 end -->
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Product from "./product";
import { reqExhibitorDetail, reqCorpColl, reqCorpCollDo, reqCorpApp, reqCorpAppDo} from "../../../api";
export default {
  components:{
    Product,
  },
  data(){
    return{
      id:0,//展商id
      ocid:0,
      datas:{},//数据
      xgcp:{},//展品列表
      collect:1,//展商收藏状态
      meet:1,//约见状态
      inquiry1:false,
      dialogFormVisible:false,//预约弹窗
      rules:{//正则校验
        // title:[{required: true, message: '请输入预约标题', trigger: 'blur'}],
        date:[{ type: 'date', required: true, message: '请选择日期', trigger: 'change' }],
        // chooseTime1:[{ type: 'date', required: true, message: '请选择时间', trigger: 'change' }],
        // chooseTime2:[{ type: 'date', required: true, message: '请选择时间', trigger: 'change' }],
        connet:[{required: true, message: '请输入留言', trigger: 'blur'}],
      },
      preAboutData:{
        id:0,
        // title:'',
        date:"",
        // chooseTime1:"",
        // chooseTime2:"",
        connet:"",

      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;//如果没有后面的-8.64e7就是不可以选择今天的
        }
      }
    }
  },
  mounted(){
    let id = this.$route.path.split('/')
    this.id=id[id.length-2]*1
    this.ocid = id[id.length-1]*1
    this.reqDetail(this.id)
    this.initCollect(this.ocid)
    this.initCorpApp(this.ocid)
    if (!this.isLogin) {
      this.$router.push('/home')
    }
  },
  methods:{
     submitForm(formName) {//预约表单
      this.$refs[formName].validate(async(valid) => {
        if (valid) {//发送
          this.preAboutData.id=this.ocid
          const response = await reqCorpAppDo(this.preAboutData)
          if (response.code==0) {
            this.meet=response.is_coll
            this.success(this,'预约成功！')
            this.dialogFormVisible=false
          }else{
            this.err(this,'预约失败，请稍后重试...')
          }
        } else {//错误
          return false;
        }
      });
    },

    resetForm() {//预约表单重置
      this.$refs.preAboutData.resetFields();
      this.dialogFormVisible=false
    },
    
    async reqDetail(id){// 请求详情及列表
      const response = await reqExhibitorDetail(id)
      if(response.code==0){
          this.datas=response.resilt[0]
          this.xgcp = {
            name:"展品展示",
            list:response.resilt[1]
          }
      }else{
        this.$router.push("/")
      }
    },
    
    async initCollect(ocid){// 初始获取收藏状态
      const response = await reqCorpColl(ocid)
      if (response.code==0) {
        this.collect=response.is_coll
      }else{
        this.collect = 1
      }
    },
    
    async isCollect(ocid){// 修改收藏状态
      const response = await reqCorpCollDo(ocid)
      if (response.code==0) {
        this.collect=response.is_coll
      }else{
        this.collect = 1
      }
    },
    
    // 初始化约见状态++++
    async initCorpApp(ocid){
      const response = await reqCorpApp(ocid)
      if (response.code==0) {
        this.meet=response.is_coll
      }
    },
    // 修改约见状态
    async isCorpApp(ocid){
      if (!this.meet) {
        return
      }
      this.ocid = ocid
      this.dialogFormVisible = true
      // const response = await reqCorpAppDo(ocid)
      // if (response.code==0) {
      //   this.meet=response.is_coll
      // }
    },
  },
  computed:{
    ...mapState({
      isLogin:state=>state.user.isLogin,
    })
  }

}
</script>

<style scoped>
.p_zsxq{
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  padding-bottom: 30px;
  /* background-color: white; */
}
.zsNav{
  position: absolute;
  left: 10px;
  top: 10px;
  font-size: 14px;
  font-weight: 600;
}
.zsNav span{
  cursor: pointer;
}
.zsNav span:hover{
  color: #008baf;
}
.zsxqHeader{
  background-image: url("https://e.cippe.com.cn/public/images/2021/exhibit/zsxqbg.png");
  width: 100%;
  height: 180px;
  padding-top: 60px;
  box-sizing: border-box;
}
.zsxqHeader::after{
  content: "";
  display: block;
  clear: both;
}
.zsxqImg{
  float: left;
  width: 80px;
  height: 80px;
  /* border-radius: 50%; */
  border: 1px solid #aaa;
  overflow: hidden;
}
.zsmz{
  float: left;
  margin-left: 20px;
  /* line-height: 30px; */
}
.zsmz h2{
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 16px;
  padding-left: 10px;
}
.zsmz p{

}
.zsmz button{
  font-size: 14px;
  padding: 2px 4px;
  margin-right: 10px;
  background-color: white;
  border: 1px solid #e8e8e8;
  outline: none;
  font-weight: 600;
}
.zsmz button .zsB2{
  color: #008baf;
}
.zsmz button:focus{
  /* border: none; */
}
/* 主体内容 */
  .zsxqContent{
    width: 100%;
    display: table;
    margin-bottom: 40px;
  }
  .zsxqContent::after{
    content: "";
    display: block;
    clear: both;
  }
  .zsxqContent>div{
    /* float: left; */
    display: table-cell;
    font-size: 14px;
  }
  .zsnrL{
    padding: 30px 4% 30px 0;
    width: 62%;
    /* height: 100%; */
  }
  .zsnrL>div{
    width: 100%;
  }
  .zsxqContent h3{
    font-size: 20px;
    color: #008baf;
    font-weight: 600;
    padding-bottom: 10px;
  }
  .zsnrL p{
    text-indent: 2em;
    font-size: 14px;
    line-height: 28px;
    letter-spacing: .1em;
  }
  .zsnrL .interactionButton{
    margin-top: 40px;
    text-align: center;
  }
  .zsnrL .interactionButton button{
    margin-left: 40px;
    padding: 10px 40px;
    border: none;
    background-color: #008baf;
    border-radius: 4px;
    color: white;
    letter-spacing: 10px;
    transition: all .3s;
    cursor: pointer;
    font-size: 14px;
  }
  .zsnrL .interactionButton button:first-child{
    margin-left: 0;
  }
  .zsnrL .interactionButton .collectActive,
  .zsnrL .interactionButton button:focus,
  .zsnrL .interactionButton button:hover{
    background-color: #ff840b;
    border: none;
    outline: none;
  }
  .interactionButton i{
    font-size: 18px;
    vertical-align: middle;
  }

  .zsnrR{
    background-color: #eee;
    padding: 30px 0 30px 20px;
    width: 38%;
    box-sizing: border-box;
    /* height: 100%; */
  }
  .zsnrR p{
    margin-top: 16px;
    display: table;
  }
  .zsnrR>p>i{
    font-size: 16px;
    width: 36px;
    text-align: center;
    /* display: inline-block; */
    color: #008baf;
    display: table-cell;
  }
  .zplb{
    /* margin-top: 30px; */
    width: 100%;
    background-color: #eeeeee;
  }

  /* 操作 start */
  .exchange{
    margin-bottom: 40px;
    width: 100%;
  }
  .exchange img{
    width: 20px;
  }
  .exchangeItem{
    width: calc(50% - 10px);
    padding: 10px 30px;
    background-color: #f7f7f7;
    display: inline-block;
  }
  .exchangeItem:first-child{
    margin-right: 20px;
  }
  .exchangeTop{
    font-size: 22px;
    font-weight: 600;
    color: #000;
    padding-bottom: 20px;
  }
  .exchangeTop img{
    float: right;
    width: 80px;
  }
  .exchangeTop::after{
    content: "";
    display: block;
    clear: both;
  }
  .exchangeBtn{
    width: 100%;
  }
  .exchangeBtn>button{
    width: 100%;
    line-height: 40px;
    font-size: 18px;
    font-weight: 600;
    color: #008baf;
    border: 2px solid #008baf;
    background-color: white;
    outline: none;
    cursor: pointer;
    transition: all .5s;
  }
  .exchangeBtn1>button{
    width: 100%;
    line-height: 40px;
    font-size: 18px;
    font-weight: 600;
    color: white;
    border: 2px solid #008baf;
    background-color: #008baf;
    outline: none;
    cursor: pointer;
    transition: all .5s;
  }
  .exchangeBtn>.btnACtive,
  .exchangeBtn>button:hover{
    color: white;
    background-color: #008baf;
  }
  .exchangeBtn1>.btnACtive,
  .exchangeBtn1>button:hover{
    color: white;
    background-color:#055d74;
    border-color:#055d74;
  }
    /* 操作 end */
</style>
<style scoped>
/* 预约弹窗 */
.yuyue>>> .el-dialog{
  background-color: white;
}
.yuyue >>> .el-dialog__body{
  padding: 20px 80px 20px 60px;
}
.yuyue >>>.el-form-item--mini.el-form-item,
.yuyue >>>.el-form-item--small.el-form-item{
  margin-bottom: 24px;
}
.yuyue >>>.el-form-item__label{
  line-height: 40px;
}
.yuyue >>>.el-input .el-input__inner{
  line-height: 40px;
  height: 40px;
}
.yuyue>>>.el-col-2{
  text-align: center;
  line-height: 40px;
}
.yuyue >>> .el-textarea__inner{
  width: 100%;
  padding: 10px;
  border-radius: 4px;
  font-size: 14px;
  height: 140px;
}
.yuyue >>> .el-textarea__inner:focus,
.yuyue>>>.el-input__inner:focus{
  border-color: #008baf;
}
</style>
<style scoped>
/* zxkf */
.zxkf{
    position: fixed;
    right: 0;
    top: 30%;
    width: 80px;
    height: 84px;
    color: #008baf;
    border-radius: 10px;
    box-shadow: 0 0 4px #ccc;
    transition: all .5s;
  }
  .zxkf .divimg{
    height: 64px;
    background: url(https://e.cippe.com.cn/public/images/service-blue.png) no-repeat;
    background-position: center;
  }
  .zxkf > p{
    text-align: center;
    font-size: 12px;
  }
  .zxkfPopover{
    opacity: 0;
    position: absolute;
    top: 0%;
    right: 80px;
    color: #000;
    width: 190px;
    height: 84px;
    padding: 10px;
    font-size: 14px;
    font-weight: bold;
    box-shadow: 0 0 4px #ccc;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    background-color: #fff;
    transition: all .5s;
  }
  .zxkf:hover{
    background-color: #008baf;
    color: #fff;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .zxkf:hover .divimg{
    background: url(https://e.cippe.com.cn/public/images/service-white.png) no-repeat;
    background-position-x: center;
    color: #fff;
  }
  .zxkf:hover .zxkfPopover{
    opacity: 1;
  }
</style>
